import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_SAP_SYNC

export default class SyncPagosService {
  sincronizarPagosRecibidos (payload) {
    return http.post(`${baseUrl}/pagos/aprobar`, payload, {
      headers: {
        loading: true
      }
    })
  }

  find (ov) {
    return http.get(`${baseUrl}/pagos/find/${ov}`, {
      headers: {
        loading: true
      }
    })
  }

  registrar () {
    return http.post(`${baseUrl}/pagos/registrar`, {}, {
      headers: {
        loading: true
      }
    })
  }

  eliminar (numOv) {
    return http.delete(`${baseUrl}/pagos/eliminar/${numOv}`, {}, {
      headers: {
        loading: true
      }
    })
  }
}
